import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin(nuxtApp => {
  const { sentryDSN, sentryEnvironment } = useRuntimeConfig().public
  const SENTRY_ALLOWED_ENVS = ['production', 'staging']
  // Only initialize Sentry in allowed environments and if the DSN is provided
  if (!sentryDSN || !SENTRY_ALLOWED_ENVS.some(env => sentryEnvironment?.includes(env))) {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentryDSN,
    environment: sentryEnvironment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],

    // Lowered sample rates to reduce quota usage
    tracesSampleRate: 0.005, // Capture 0.5% of transactions
    replaysSessionSampleRate: 0.001, // Capture 0.1% of user sessions
    replaysOnErrorSampleRate: 0.001, // Capture replays for 0.1% of errors
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: [
    //   // Frontend domains
    //   /^https:\/\/(www\.|uat\.|develop\.)?compareclub\.com\.au\//,
    //   // Compare Club API (dev, staging, prod, with/without /memberhub)
    //   /^https:\/\/(dev\.|staging\.)?api\.compareclub\.com\.au(\/memberhub)?\//,
    //   // Alternative Media API (dev, staging, prod)
    //   /^https:\/\/(dev\.|staging\.)?api\.alternativemedia\.com\.au\//,
    //   /^https:\/\/api\.alternativemedia\.com\.au\//
    // ],

    ignoreErrors: [
      // Add known, non-actionable errors here
      'Network Error',
      'Non-Error promise rejection captured',
      '/_nuxt/builds/meta/'
    ],

    beforeSend (event) {
      // Only log in development
      // Continue sending to Sentry
      return event
    }
  })

})
